<template>
  <div>
    <div class="title-bar clearfix">
      <div class="module pull-left">
        {{$t("productReturn.title")}}
      </div>
      <div class="btn-group pull-right">
        <el-button v-if="canExport" class="sm-hidden" :plain="true" :loading="exporting" size="mini" @click="exportExcel">{{ $t("export") }}
          <i class="fa fa-download"></i>
        </el-button>
        <el-button v-if="canScan" class="sm-hidden" :plain="true" size="mini" @click="beginScan">{{ $t("productReturn.returnScan") }}
          <i class="fa fa-qrcode"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>
      </div>
    </div>
    <div class="data-list" v-loading="loading" element-loading-text="Loading">
      <el-table stripe :data="returnRecords" size="mini" class="customer-table">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table border stripe :data="scope.row.Details" size="mini" class="customer-table">
              <el-table-column type="index" width="50" :label="$t('serialNumber')" align="center">
              </el-table-column>
              <el-table-column v-for="col in detailTableCols" :key="col.prop" :prop="col.prop" align="center" :resizable="true" :label="$t(col.label)" :width="col.width" :show-overflow-tooltip="true">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" align="center" :resizable="true" :label="$t('productReturn.createTime')" :formatter="timeFormatter">
        </el-table-column>
        <el-table-column prop="Remark" align="center" :resizable="true" :label="$t('productReturn.remark')">
        </el-table-column>
        <el-table-column prop="Count" align="center" :resizable="true" :label="$t('productReturn.count')">
        </el-table-column>
        <el-table-column prop="UserName" align="center" :resizable="true" :label="$t('productReturn.userName')">
        </el-table-column>
      </el-table>

      <el-row class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-row>

      <!-- search dialog -->
      <el-dialog class="search-dialog" :title="$t('search')" :visible.sync="searchDialogVisible">
        <el-form class="search-form" :model="filter" :inline="true" size="small" label-width="70px">
          <el-form-item :label="$t('productReturn.userName')" size="small">
            <el-input v-model="filter.userName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('productReturn.remark')" size="small">
            <el-input v-model="filter.remark"></el-input>
          </el-form-item>

          <el-form-item :label="$t('productReturn.qrcode1')" size="small">
            <el-input v-model="filter.qrcode1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('productReturn.orderNumber')" size="small">
            <el-input v-model="filter.orderNumber"></el-input>
          </el-form-item>

          <el-form-item :label="$t('productReturn.createTime')" size="small">
            <el-date-picker v-model="filter.startTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('to')" size="small">
            <el-date-picker v-model="filter.endTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-form>

        <div slot="footer" class="search-footer">
          <el-button @click="searchDialogVisible = false" :plain="true" size="mini">{{$t('cancel')}}</el-button>
          <el-button @click="resetFilter" :plain="true" size="mini">{{$t('reset')}}</el-button>
          <el-button type="primary" @click="search" :plain="true" size="mini">{{$t('confirm')}}</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import roleTypes from "../../../models/roleTypes";
import searchTypes from "../../../models/searchTypes";
import searchHistoryService from "../../../services/searchHistoryService";
import fileSaver from "file-saver";
import { mapGetters } from "vuex";
export default {
  name: "ProductReturn",
  data() {
    return {
      searchDialogVisible: false,
      returnRecords: [],
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      loading: false,
      exporting: false,
      filter: {},
      filterOptions: [],
      detailTableCols: [
        {
          prop: "QRCode1",
          label: "productReturn.qrcode1",
          width: 200,
          formatter: null
        },
        {
          prop: "IwacInfo.CustomerNumber",
          label: "productReturn.customerNumber",
          width: 100,
          formatter: null
        },
        {
          prop: "IwacInfo.CustomerName",
          label: "productReturn.customerName",
          width: 200,
          formatter: null
        },
        {
          prop: "IwacInfo.OrderNumber",
          label: "productReturn.orderNumber",
          width: 100,
          formatter: null
        },
        {
          prop: "IwacInfo.BoxNumber",
          label: "productReturn.boxNumber",
          width: 200,
          formatter: null
        },
        {
          prop: "EanInfo.EANcode",
          label: "productReturn.eancode",
          formatter: null
        },
        {
          prop: "EanInfo.ProductLongCode",
          label: "productReturn.longcode",
          formatter: null
        },
        {
          prop: "IwacInfo.DeliveryTime",
          label: "productReturn.deliveryTime",
          formatter: this.timeFormatter
        }
      ]
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getReturnRecords();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getReturnRecords();
    },
    getReturnRecords() {
      this.loading = true;
      let params = {
        filter: JSON.stringify(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios
        .get("api/product/return", { params })
        .then(res => {
          this.totalCount = res.data.TotalCount;
          this.returnRecords = res.data.Data;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      searchHistoryService.setHistory(
        searchTypes.PRODUCTRETURN_HISTORY,
        this.filterOptions
      );
      this.getReturnRecords();
    },
    resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.PRODUCTRETURN_HISTORY);
    },
    setFilterOptions() {
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (typeof val === "number" || val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh() {
      this.resetFilter();
      this.getReturnRecords();
    },
    initializeFilter() {
      let his = searchHistoryService.getHistory(
        searchTypes.PRODUCTRETURN_HISTORY
      );
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    beginScan() {
      this.$router.push({ name: "ReturnScan" });
    },
    exportExcel() {
      this.exporting = true;
      let params = {
        filter: JSON.stringify(this.filterOptions)
      };
      this.$axios
        .get("api/product/return/export", { params })
        .then(resp => {
          let fileName = decodeURIComponent(
            resp.headers["file-name"] || "退货记录.csv"
          );
          const BOM = "\ufeff";
          let blob = new Blob([BOM + resp.data]);
          fileSaver.saveAs(blob, fileName);
          this.exporting = false;
        })
        .catch(e => {
          this.exporting = false;
        });
    }
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
    canExport(){
        return (
        this.roles.includes(roleTypes.Administrator) ||
        this.permissions.find(p => p.toLowerCase() === "productreturn.export")
      );
    },
    canScan() {
      return (
        this.roles.includes(roleTypes.Administrator) ||
        this.permissions.find(p => p.toLowerCase() === "productreturn.insert")
      );
    }
  },
  created() {
    this.initializeFilter();
    this.getReturnRecords();
  }
};
</script>

<style lang="scss">

</style>










// WEBPACK FOOTER //
// src/components/application/ProductReturn/ProductReturn.vue